import { render, staticRenderFns } from "./ReviewDiagnosis.vue?vue&type=template&id=e0faf072"
import script from "./ReviewDiagnosis.vue?vue&type=script&lang=js"
export * from "./ReviewDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports